import { zs } from './zod';

export const shortTextField = zs.string().trim().max(200);
